/* tps-special.js · the live countdown + midnight swap for the homepage "Today's special" block (30 Oct 2026, Midas).
   Markup: snippets/tps-potd-card.liquid, state: snippets/tps-special.liquid. Own code, no library.

   special state  <section data-potd="special" data-end="EPOCH_SECONDS">  server renders the end time + the first clock reading;
                  this file counts down from the device clock (device clock, Melbourne day guard) and paints HH:MM:SS.
   plain state    <section data-potd="plain">  no offer. This file only WATCHES: it wakes at the next Melbourne midnight to look for a
                  special that has just started (so a tab left open across midnight still updates).

   AT THE END (00:00:00 on the dot): the offer is removed at once, by swapping in the fallback block that the server rendered inside
   <template data-potd-fb> (no request, no false offer, not one frame of a stale price). Then the section is fetched through the
   Section Rendering API every 5 s for up to 3 minutes until a NEW special arrives (the Worker writes it within seconds of midnight),
   and it is swapped in place. A page that loads after the end, or comes from a cache, never shows an expired offer: the first
   tick sees the end has passed and swaps before anything is read.

   Timing: no setInterval drift (each tick is scheduled to the next second boundary); ticking pauses while the tab is hidden and
   resyncs on visibilitychange. Nothing animates, so reduced motion needs no branch. The clock is role="timer" (aria-live off), so it is
   never announced per second; the swap is announced once through one polite status line.

   TEST ONLY (guarded: the server prints data-test="1" only while theme.role != 'main', an unpublished copy):
     ?tps_special_test_end=20         the special ends 20 s after load (seconds), or an ISO time with offset.
   On the live theme data-test is absent, so the flag is ignored and can never affect a visitor. */
(function (w, d) {
  'use strict';
  if (w.__tpsSpecial) return;
  w.__tpsSpecial = 1;

  var SEL = '[data-potd]';
  var TZ = 'Australia/Melbourne';
  var POLL_MS = 5000, POLL_FOR = 180000;
  var done = {};
  var st = { day: '', key: '', root: null, wrap: null, id: '', mode: '', end: 0, serverEnd: 0, skew: 0, timer: 0, poll: 0, pollUntil: 0, forced: false, shown: '', announce: null, verified: false };

  function now() { return Date.now() + st.skew; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ms to the next Melbourne midnight, from Intl (no library). Recomputed on every tick, so a clock-change night self-corrects. */
  var fmt = null;
  function melRemain() {
    try {
      fmt = fmt || new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' });
      var p = fmt.formatToParts(new Date(now())), h = 0, m = 0, s = 0;
      for (var i = 0; i < p.length; i++) { if (p[i].type === 'hour') h = +p[i].value; else if (p[i].type === 'minute') m = +p[i].value; else if (p[i].type === 'second') s = +p[i].value; }
      return (86400 - (h * 3600 + m * 60 + s)) * 1000 - (now() % 1000);
    } catch (e) { return 6e7; }
  }

  /* today's date in Melbourne, YYYY-MM-DD (en-CA formats as ISO). The special belongs to ONE Melbourne day, never longer. */
  var dfmt = null;
  function melDay() {
    try {
      dfmt = dfmt || new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' });
      return dfmt.format(new Date(now()));
    } catch (e) { return ''; }
  }
  /* an ended special never comes back: remembered for this tab (and across reloads in it) by product + day */
  function isDone(k) { if (done[k]) return true; try { return w.sessionStorage.getItem('tpsSpecialDone:' + k) === '1'; } catch (e) { return false; } }
  function markDone(k) { done[k] = 1; try { w.sessionStorage.setItem('tpsSpecialDone:' + k, '1'); } catch (e) {} }
  function okNew(n) {
    var e = (+n.getAttribute('data-end') || 0) * 1000, k = n.getAttribute('data-key') + '|' + n.getAttribute('data-day');
    return e > now() && e !== st.serverEnd && n.getAttribute('data-day') === melDay() && !isDone(k);
  }

  function testEnd() {
    if (!st.root || st.root.getAttribute('data-test') !== '1') return 0;
    var v = (new URLSearchParams(w.location.search)).get('tps_special_test_end');
    if (!v) return 0;
    if (/^\d+$/.test(v)) return Date.now() + (+v) * 1000;
    var t = Date.parse(v);
    return t || 0;
  }

  function status(msg) {
    if (!st.wrap) return;
    if (!st.announce || !st.wrap.contains(st.announce)) {
      st.announce = d.createElement('span');
      st.announce.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
      st.announce.setAttribute('role', 'status');
      st.announce.setAttribute('aria-live', 'polite');
      st.wrap.appendChild(st.announce);
    }
    st.announce.textContent = msg;
  }

  function bind(root, first) {
    st.root = root;
    st.wrap = root.closest('.shopify-section') || root.parentNode;
    st.id = (st.wrap.id || '').replace('shopify-section-', '');
    st.mode = root.getAttribute('data-potd');
    st.clock = root.querySelector('[data-potd-clock]');
    st.day = root.getAttribute('data-day') || '';
    st.key = (root.getAttribute('data-key') || '') + '|' + st.day;
    st.serverEnd = (+root.getAttribute('data-end') || 0) * 1000;
    st.end = st.serverEnd;
    st.forced = false;
    var te = testEnd();
    if (st.mode === 'special' && te && first) { st.end = te; st.forced = true; }
    if (st.mode === 'plain') { var te2 = testEnd(); st.end = te2 && first ? te2 : now() + melRemain(); st.forced = !!(te2 && first); }
    st.shown = '';
    plate(root);
    /* never restarts: a special that already ended in this tab (same product, same day) does not come back on reload or on a stale page */
    if (st.mode === 'special' && !st.forced && isDone(st.key)) { ended(); return; }
    tick();
    if (st.mode === 'special' && first && !st.forced) { idle(verify); }
  }

  function idle(fn) { (w.requestIdleCallback || function (f) { return setTimeout(f, 1200); })(fn); }

  /* The Vitrine (31 Oct): the clock is six digit cells (data-d 0..5). Only a digit that changes rolls (old up and out, new up
     and in, 320 ms, transform only); reduced motion swaps in place. Red in the last hour: the real end, never reset. */
  var RM = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)');
  function roll(cell, c) {
    var cur = cell.lastElementChild;
    if (cur && cur.textContent === c) return;
    if (!cur || (RM && RM.matches)) { cell.innerHTML = '<span>' + c + '</span>'; return; }
    cell.querySelectorAll('.is-out').forEach(function (o) { o.remove(); });
    cur.className = 'is-out';
    var n = d.createElement('span'); n.className = 'is-in'; n.textContent = c; cell.appendChild(n);
    setTimeout(function () { if (cur.parentNode === cell) cur.remove(); }, 360);
  }
  function paint(rem) {
    if (st.mode !== 'special' || !st.clock) return;
    var sec = Math.ceil(rem / 1000), h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
    var txt = pad(h) + ':' + pad(m) + ':' + pad(s);
    if (txt === st.shown) return;
    st.shown = txt;
    var cells = st.clock.querySelectorAll('[data-d]');
    if (cells.length === 6) { var dg = txt.replace(/:/g, ''); for (var i = 0; i < 6; i++) roll(cells[i], dg.charAt(i)); }
    else st.clock.textContent = txt;
    if (st.root) st.root.classList.toggle('is-urgent', sec <= 3600);
  }
  /* the plate takes the photo's own backdrop colour (mean of its four corners), so the product stands with no visible edge.
     The image is served by Shopify's CDN with CORS; if the canvas is tainted or the read fails, the neutral --plate stays. */
  function plate(root) {
    var img = root && root.querySelector('.tps-potd__img img'), box = img && img.parentNode;
    if (!img || !box || box.__plated) return;
    box.__plated = 1;
    var run = function () {
      try {
        var c = d.createElement('canvas'), n = 24; c.width = n; c.height = n;
        var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, n, n);
        var px = [[1, 1], [n - 2, 1], [1, n - 2], [n - 2, n - 2]].map(function (p) { return x.getImageData(p[0], p[1], 1, 1).data; });
        var rgb = [0, 1, 2].map(function (k) { return Math.round(px.reduce(function (a, q) { return a + q[k]; }, 0) / px.length); });
        if (rgb[0] + rgb[1] + rgb[2] > 540) box.style.background = 'rgb(' + rgb.join(',') + ')';
      } catch (e) {}
    };
    if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
  }

  function tick() {
    clearTimeout(st.timer);
    if (d.hidden || !st.root) return;
    var rem;
    if (st.mode === 'plain' && !st.forced) { st.end = now() + melRemain(); }
    rem = st.end - now();
    /* Melbourne day guard (Antiphon C6): the treatment goes at 00:00 Melbourne even if the clock, the cache or the Worker is wrong */
    if (st.mode === 'special' && !st.forced && st.day && melDay() !== st.day) rem = 0;
    if (rem <= 0) { ended(); return; }
    paint(rem);
    var wait = rem % 1000; if (wait === 0) wait = 1000;
    if (st.mode === 'special' && !st.clock) wait = Math.min(rem, 15000); /* no visible clock: only the end and the day guard matter */
    if (st.mode === 'plain' && !st.forced && rem > 60000) wait = Math.min(rem - 55000, 30000); /* the watcher sleeps; wakes in the last minute */
    st.timer = setTimeout(tick, wait + 8);
  }

  /* the end. Special: remove the offer NOW (swap in the server-rendered fallback), then watch for a new special. */
  function ended() {
    clearTimeout(st.timer);
    if (st.mode === 'special' && st.root) {
      markDone(st.key);
      var tpl = st.root.parentNode && st.root.parentNode.querySelector('template[data-potd-fb]');
      var had = focusInside();
      if (tpl && tpl.content && tpl.content.firstElementChild) {
        var fresh = d.importNode(tpl.content.firstElementChild, true);
        st.root.replaceWith(fresh);
        st.root = fresh; st.mode = 'plain'; st.clock = null; plate(fresh);
        if (had) refocus(fresh);
      } else {
        st.root.remove(); st.root = null; st.mode = 'plain';
      }
      status('Today’s special has ended.');
    }
    st.forced = false;
    st.pollUntil = Date.now() + POLL_FOR;
    poll();
  }

  function focusInside() { return !!(st.root && d.activeElement && st.root.contains(d.activeElement)); }
  function refocus(root) { var b = root.querySelector('[data-addw]'); if (b) { try { b.focus({ preventScroll: true }); } catch (e) {} } }

  function url() {
    var q = new URLSearchParams(w.location.search);
    q.set('sections', st.id);
    q.set('_', String(Date.now()));
    return w.location.pathname + '?' + q.toString();
  }

  /* one Section Rendering fetch. (A server Date header was tried to correct a wrong device clock and removed: a cached response carries an old Date, which moved the end by 17 s in testing. The device clock is trusted; the server state is re-read instead.) */
  function fetchSection() {
    return fetch(url(), { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
      return r.json();
    }).then(function (j) { return j && j[st.id]; });
  }

  function parse(html) {
    if (typeof html !== 'string') return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(SEL);
  }

  /* page-load check: the cached page may be stale, or the special may have been ended early */
  function verify() {
    if (d.hidden) return;
    fetchSection().then(function (html) {
      var n = parse(html);
      if (st.mode !== 'special') return;
      if (!n || n.getAttribute('data-potd') !== 'special') { markDone(st.key); swapTo(n, 'Today’s special has ended.'); return; }
      if (okNew(n)) swapTo(n, 'Today’s special has changed.');
      else tick();
    }).catch(function () {});
  }

  function swapTo(n, msg) {
    var had = focusInside(), old = st.root;
    clearTimeout(st.timer);
    if (n) {
      var fresh = d.importNode(n, true);
      if (old && old.parentNode) old.replaceWith(fresh); else if (st.wrap) st.wrap.insertBefore(fresh, st.wrap.querySelector('script') || null);
      /* the <template data-potd-fb> that travels with a special must follow it, or the next end has no fallback */
      var wrapDoc = n.parentNode, tn = wrapDoc && wrapDoc.querySelector && wrapDoc.querySelector('template[data-potd-fb]');
      var oldT = st.wrap.querySelector('template[data-potd-fb]');
      if (oldT) oldT.remove();
      if (tn) st.wrap.appendChild(d.importNode(tn, true));
      bind(fresh, false);
      if (had) refocus(fresh);
    } else {
      if (old) old.remove();
      st.root = null; st.mode = 'plain';
    }
    if (msg) status(msg);
  }

  /* after the end: look for the next special every 5 s for 3 minutes */
  function poll() {
    clearTimeout(st.poll);
    if (d.hidden || Date.now() > st.pollUntil) return;
    fetchSection().then(function (html) {
      var n = parse(html);
      if (n && n.getAttribute('data-potd') === 'special') {
        if (okNew(n)) { st.pollUntil = 0; swapTo(n, 'A new special is on.'); return; }
      } else if (n && !st.root) {
        swapTo(n, '');
      }
      st.poll = setTimeout(poll, POLL_MS);
    }).catch(function () { st.poll = setTimeout(poll, POLL_MS); });
  }

  /* a hidden tab stops ticking; on return, resync at once (if the end passed while away, the end runs now) */
  d.addEventListener('visibilitychange', function () {
    if (d.hidden) { clearTimeout(st.timer); clearTimeout(st.poll); return; }
    if (!st.root && !st.pollUntil) return;
    if (st.pollUntil && Date.now() < st.pollUntil) poll();
    tick();
    if (st.mode === 'special' && !st.forced) idle(verify);
  });

  function boot() {
    var r = d.querySelector(SEL);
    if (r) bind(r, true);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})(window, document);
